<template>
  <!-- draggable=".item-todo" -->
  <draggable
    v-if="lanes.$readySome /*  && $ready_commitments  otherwise warnings will show up */"
    @scroll.native.passive="onScroll"
    class="lists"
    v-dragscroll:nochilddrag="!lane_dragging"
    v-model="draggablesList"
    handle=".lane-drag-handle"
    filter=".filtered"
    :disabled="false /* false && saving_drag, */"
    :move="onMove">

    <!--
    <kanban-list
      v-for="lane in lanes.asArraySorted().items"
      :key="lane.$key"
      :lane="lane"
      :goal-id="goalId"
      />
    -->
    <kanban-list
      v-for="element in draggablesList"
      :key="element.$key"
      :lane="element"
      :goal-id="goalId"
      :loading="task_loading"
      :data-element-id="element.$id"
      :data-goal-id="goalId"
      :filter-by-label="filter.show_label"
      :show-finished="kanban_settings.showFinishedTasks"
      :show-archived="kanban_settings.showArchivedTasks"
      :show-prop-task-height="kanban_settings.showPropTaskHeight"
      :search-string="filter.search_text"
      :ref="element.$id"
      :finishDates="finishDates && finishDates[element.$id] ? finishDates[element.$id] : null"
      @mouseover-event="onStartDrag"
      @mouseleave-event="onEndDrag"
      /> <!-- TODO: set url anchors too -->

    <kanban-list-unassigned
      v-if="filter.show_unassigned_tasks"
      :goal-id="goalId"
      :filter-by-label="filter.show_label"
      :show-finished="kanban_settings.showFinishedTasks"
      :show-archived="kanban_settings.showArchivedTasks"
      :show-prop-task-height="kanban_settings.showPropTaskHeight"
      />

    <!-- todo make non movable -->
    <!-- todo use slot="footer" -->
    <!-- <pre class="mini-pre">{{filter}}<hr />{{kanban_settings}}</pre> -->
    <!-- <pre class="mini-pre">{{$models.goalMember.with({ goalId }).getList()}}</pre> -->
    <!-- <pre class="mini-pre">{{lanes}}</pre> -->
    <!-- <pre class="mini-pre">goalId: {{goalId}}</pre> -->
    <!-- <pre class="mini-pre">$readySome: {{ lanes.$readySome }}</pre> -->
    <!-- <pre class="mini-pre">{{goal_meta}}</pre> -->
    <!-- <pre class="mini-pre">{{ lanes.asArraySorted().items }}</pre> -->
    <!-- <pre class="mini-pre">{{goal_user_settings.kanbanSettings}}</pre> -->
    <!--
    <div class="lane-container filtered">
      <div class="lane">
      </div>
    </div>
    -->
  </draggable>
</template>

<script>
import { mapGetters } from "vuex";
import { mapReady } from '@/api/misc'
import Draggable from 'vuedraggable';
import { dragscroll } from 'vue-dragscroll'

import { ENABLE_PROPORTIONAL_TASK_HEIGHTS } from '@/features'
import KanbanList from '@/components/GoalPage/Elements/KanbanList';
import KanbanListUnassigned from '@/components/GoalPage/Elements/KanbanListUnassigned';
import FilePromptMixin from '@/components/Mixins/Prompts/FilePrompt'

export default {
  name: "Kanban",
  mixins: [ FilePromptMixin ],
  props: {
    filter: {},
    goalId: {
      default: null,
    },
  },
  data: () => ({
    task_loading: true,
    lane_dragging: false,
    saving_drag: false,
    enable_prop_task_height: ENABLE_PROPORTIONAL_TASK_HEIGHTS
  }),
  created() {
    this.$models.task.subscribe_to_goal_tasks( this.goalId ).then(() => {
      console.log("******** LOADING DONE **********")
      this.task_loading = false;
      this.$api.set_ready('tasks:' + this.goalId )
    })
  },
  mounted() {
    if ( this.$route.hash ) {
      this.scrollToLane( this.$route.hash.slice(1) )
    }
  },
  computed: {
    ...mapGetters("dayplanner", [
      "drag_item",
      //"drag_item"
    ]),
    ...mapReady('commitments'),

    goal_user_settings() {
      return this.$models.userGoalSettings.getNode( this.goalId );
    },

    kanban_settings() {
      // TODO: Hier kommt ein Fehler, wenn goal user settings nicht existieren
      return this.goal_user_settings.kanbanSettings || {
        showFinishedTasks: true,
        showArchivedTasks: false,
      }
    },

    lanes() {
      return this.$models.commitmentMeta.with({ goalId: this.goalId }).getList();
      // let goal_lanes = getters.get_lanes_by_goal_id(goal_id);
      // return this.$models.commitment.subscribeNode
    },

    finishDatesSerialized() {
      return this.$models.commitmentTaskFinishDates.with({ goalId: this.goalId }).subscribeList();
    },

    finishDates() {
      let finishDates = {}
      if ( !this.finishDatesSerialized.$readySome ) {
        return null
      }
      //console.log('finishDates array:',this.finishDatesSerialized.itemsAsArray())
      this.finishDatesSerialized.itemsAsArray().forEach(finishDatesSerializedCommitment => {
        //console.log('finishDates finishDatesSerializedCommitment', finishDatesSerializedCommitment)
        if (finishDatesSerializedCommitment.finishDatesArray) {
          let finishDatesCommitment = JSON.parse(finishDatesSerializedCommitment.finishDatesArray)
          let commitmentId = finishDatesSerializedCommitment.$id;
          finishDates[commitmentId] = {}
          finishDates[commitmentId]['commitment'] = finishDatesCommitment[0]

          let nrFinishDatesCommitment = finishDatesCommitment.length
          if (nrFinishDatesCommitment > 2) {
            let lastTaskFinishDate = finishDatesCommitment[2]
            finishDates[commitmentId][finishDatesCommitment[1]] = finishDatesCommitment[2]
            for (let i = 3; i < nrFinishDatesCommitment; i = i + 2) {
              finishDates[commitmentId][finishDatesCommitment[i]] = lastTaskFinishDate + finishDatesCommitment[i + 1]
              lastTaskFinishDate = lastTaskFinishDate + finishDatesCommitment[i + 1]
            }
          }
        }
      })
      return finishDates
    },

    draggablesList: {
      get() {
        return this.lanes.asArraySorted().items;
      },
      set(items) {
        let batch = items.map(item => item.$id)
        this.saving_drag = true;
        this.$api.commitment_move_batch({ batch: batch, goal_id: this.goalId })
          .then(() => {
            this.saving_drag = false;
          });
      }
    },
  },
  methods: {

    onMove({ draggedContext, relatedContext, related }, originalEvent) {
      // console.log("onMove1", draggedContext.futureIndex, relatedContext.index );
      // console.log("onMove2", related, related.classList );
      return !Array.from(related.classList).includes("filtered");
    },

    onStartDrag(evt) {
      this.lane_dragging = true; // use store value instead
    },

    onEndDrag(evt) {
      this.lane_dragging = false; // use store value instead
    },

    scrollToLane( laneId ) {
      // TODO: https://stackoverflow.com/questions/40341939/how-to-create-anchor-tags-with-vue-router
      if ( laneId && this.$refs[ laneId ] ) {
        let element_to_scroll_to = this.$refs[ laneId ][0].$el;
        element_to_scroll_to.scrollIntoView();
      }
    },

    onScroll(ev) {
      this.$store.commit('app/SET_KANBAN_SCROLL_POSITION', ev.srcElement.scrollLeft)
    },
  },
  components: {
    KanbanList,
    KanbanListUnassigned,
    Draggable,
  },
  directives: {
    'dragscroll': dragscroll
  },
};
</script>

<style lang="scss">
@import './Style/Kanban.scss'
</style>

<style>
/* width */
.kanban .lists::-webkit-scrollbar {
  width: 15px;
  height: 15px;
  background: transparent;
}
/* Handle */
.kanban .lists::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.66);
  border-radius: 15px;
}
/* Handle on hover */
.kanban .lists::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 1);
}
/* Fixes issue with v-dragscroll, where background is not selected */
.kanban .lane,
.kanban .lane-container {
  pointer-events: none;
}
/* Enable pointer events again for subelement that are not height 100% */
.kanban .lane-container.filtered .lane > *,
.kanban .lane-drag-handle {
  pointer-events: auto;
}
/* -------------------------------------------------------------------------- */
.kanban .task-duration {
  flex-direction: column;
}
/* -------------------------------------------------------------------------- */
.kanban--compact .inline-editable-text {
  font-size: 10pt;
  font-weight: bold;
  line-height: 1.3;
}
.kanban--compact .task-duration {
  line-height: 1.3;
  flex-direction: row;
}
.kanban--compact .task-list-item-infos {
  /*display: none;*/
}
.kanban--compact .task .task__checkbox {
  padding-top: 0;
}
.kanban--compact .task .task-image {
  width: 50%;
  margin: 0.25em auto;
  border: 1px solid gray;
}
.kanban--compact .list .list-inner .task {
  padding: 4px 5px;
  margin-top: 0;
  /*box-shadow: 0 1px 1px rgba(0, 0, 0, 0.32);*/
  font-size: 0.9em;
}
.kanban--compact .task-list-header .commitment-picture {
  height: 35px;
}
.kanban--compact .task-list-header__info > div {
  display: none;
}
.kanban--compact .task-list-header {
  height: 85px;
  min-height: unset;
}
.kanban--compact .task-list-header__info img {
  margin: 0 !important;
}
.kanban--compact .task-list-header img {
  width: 30px;
  height: 30px;
}
.kanban--compact .list .list-inner {
  max-height: calc(100vh - 330px);
}
/* -------------------------------------------------------------------------- */
/* .kanban--column-layout .lists {
  height: calc(100vh - 51px);
  column-width: 300px;
  column-gap: 10px;
  display: block;
}
.kanban--column-layout .lane-container {
  break-inside: avoid-column;
  margin-bottom: 1em;
} */
.kanban--column-layout .lists {
  height: calc(100vh - 51px);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
}
.kanban--column-layout .lane-container {
  margin-bottom: 1em;
  width: 300px;
}
</style>
